import React, { Component } from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { Redirect, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { IntlProvider } from "react-intl";
import "assets/vendors/style";
import indigoTheme from "./themes/indigoTheme";
import cyanTheme from "./themes/cyanTheme";
import orangeTheme from "./themes/orangeTheme";
import amberTheme from "./themes/amberTheme";
import pinkTheme from "./themes/pinkTheme";
import blueTheme from "./themes/blueTheme";
import purpleTheme from "./themes/purpleTheme";
import greenTheme from "./themes/greenTheme";
import darkTheme from "./themes/darkTheme";
import AppLocale from "../lngProvider";
import { isUserAuthenticated, isAuthenticated } from "../helpers/authUtils";
import { userSignOut } from "../actions/Auth";

import {
  AMBER,
  BLUE,
  CYAN,
  DARK_AMBER,
  DARK_BLUE,
  DARK_CYAN,
  DARK_DEEP_ORANGE,
  DARK_DEEP_PURPLE,
  DARK_GREEN,
  DARK_INDIGO,
  DARK_PINK,
  DEEP_ORANGE,
  DEEP_PURPLE,
  GREEN,
  INDIGO,
  PINK,
} from "constants/ThemeColors";

import MainApp from "app/index";
import ApplicantApp from "applicant/index";
import AdminApp from "admin/index";
import StudentApp from "student/index";
import ApplicantSignin from "./ApplicantSignin";
import AdminSignin from "./AdminSignin";
import StudentSignin from "./StudentSignin";
import QrCode from "./QrCode";
import PaymentReceipt from "./paymentReceipt";
import AdmissionLetter from "./AdmissionLetter";
import SiwesLetter from "./SiwesLetter";
import SignIn from "./SignIn";
import ForgotPassword from "./ForgotPassword";
import Home from "./Home";
import ConFirmNewPassword from "./ConfirmNewPassword";
import { setInitUrl } from "../actions/Auth";
import RTL from "util/RTL";
import asyncComponent from "util/asyncComponent";
import ConfirmNewPassword from "./ConfirmNewPassword";

const RestrictedRoute = ({
  component: Component,
  authUser,
  signinPath,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated(authUser) ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: signinPath,
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

class App extends Component {
  componentWillMount() {
    // eslint-disable-next-line no-underscore-dangle
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
    if (this.props.initURL === "") {
      this.props.setInitUrl(this.props.history.location.pathname);
    }
  }

  getColorTheme = (themeColor, applyTheme) => {
    switch (themeColor) {
      case INDIGO: {
        applyTheme = createMuiTheme(indigoTheme);
        break;
      }
      case CYAN: {
        applyTheme = createMuiTheme(cyanTheme);
        break;
      }
      case AMBER: {
        applyTheme = createMuiTheme(amberTheme);
        break;
      }
      case DEEP_ORANGE: {
        applyTheme = createMuiTheme(orangeTheme);
        break;
      }
      case PINK: {
        applyTheme = createMuiTheme(pinkTheme);
        break;
      }
      case BLUE: {
        applyTheme = createMuiTheme(blueTheme);
        break;
      }
      case DEEP_PURPLE: {
        applyTheme = createMuiTheme(purpleTheme);
        break;
      }
      case GREEN: {
        applyTheme = createMuiTheme(greenTheme);
        break;
      }
      case DARK_INDIGO: {
        applyTheme = createMuiTheme(indigoTheme);
        break;
      }
      case DARK_CYAN: {
        applyTheme = createMuiTheme(cyanTheme);
        break;
      }
      case DARK_AMBER: {
        applyTheme = createMuiTheme(amberTheme);
        break;
      }
      case DARK_DEEP_ORANGE: {
        applyTheme = createMuiTheme(orangeTheme);
        break;
      }
      case DARK_PINK: {
        applyTheme = createMuiTheme(pinkTheme);
        break;
      }
      case DARK_BLUE: {
        applyTheme = createMuiTheme(blueTheme);
        break;
      }
      case DARK_DEEP_PURPLE: {
        applyTheme = createMuiTheme(purpleTheme);
        break;
      }
      case DARK_GREEN: {
        applyTheme = createMuiTheme(greenTheme);
        break;
      }
      default:
        createMuiTheme(indigoTheme);
    }
    return applyTheme;
  }

  render() {
    const {
      match,
      location,
      themeColor,
      isDarkTheme,
      locale,
      authUser,
      initURL,
      isDirectionRTL,
      qrCodeAuth,
      applicantAuth,
      adminAuth,
      studentAuth,
    } = this.props;
    const userAuthentication = isUserAuthenticated();
    if (userAuthentication === false) {
      userSignOut();
    }
    let applyTheme = createMuiTheme(orangeTheme);
    if (isDarkTheme) {
      document.body.classList.add("dark-theme");
      applyTheme = createMuiTheme(darkTheme);
    } else {
      applyTheme = this.getColorTheme(themeColor, applyTheme);
    }
    const currentAppLocale = AppLocale[locale.locale];
    let path = location.pathname.split("/")[1];

    if (
      location.pathname === "/applicant" ||
      location.pathname === "/applicant/" ||
      location.pathname === "/Applicant"
    ) {
      return <Redirect to={"/ApplicantSignin"} />;
    } else if (
      location.pathname === "/admin" ||
      location.pathname === "/admin/" ||
      location.pathname === "/Admin"
    ) {
      return <Redirect to={"/AdminSignin"} />;
    } else if (
      location.pathname === "/student" ||
      location.pathname === "/student/" ||
      location.pathname === "/Student"
    ) {
      return <Redirect to={"/StudentSignin"} />;
    }
    // else if (
    //   location.pathname === "/qrCode" ||
    //   location.pathname === "/qrCode/" ||
    //   location.pathname === "/QrCode"
    // ) {
    //   return <Redirect to={"/QrCode"} />;
    // }
    else if (
      location.pathname === "/admissionletter" ||
      location.pathname === "/AdmissionLetter/" ||
      location.pathname === "/admissionLetter"
    ) {
      return <Redirect to={"/AdmissionLetter"} />;
    } else if (
      location.pathname === "/siwesletter" ||
      location.pathname === "/SiwesLetter/" ||
      location.pathname === "/siwesLetter"
    ) {
      return <Redirect to={"/SiwesLetter"} />;
    }

    if (isDirectionRTL) {
      applyTheme.direction = "rtl";
      document.body.classList.add("rtl");
    } else {
      document.body.classList.remove("rtl");
      applyTheme.direction = "ltr";
    }

    return (
      <MuiThemeProvider theme={applyTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <IntlProvider
            locale={currentAppLocale.locale}
            messages={currentAppLocale.messages}
          >
            <RTL>
              <div className="app-main">
                <Switch>
                  {path === "app" && (
                    <RestrictedRoute
                      path={`${match.url}app`}
                      authUser={authUser}
                      component={MainApp}
                      signinPath="/signin"
                    />
                  )}

                  {path === "applicant" && (
                    <RestrictedRoute
                      path={`${match.url}applicant`}
                      component={ApplicantApp}
                      authUser={applicantAuth}
                      signinPath="/ApplicantSignin"
                    />
                  )}

                  {path === "admin" && (
                    <RestrictedRoute
                      path={`${match.url}admin`}
                      component={AdminApp}
                      authUser={adminAuth}
                      signinPath="/AdminSignin"
                    />
                  )}

                  {path === "student" && (
                    <RestrictedRoute
                      path={`${match.url}student`}
                      component={StudentApp}
                      authUser={studentAuth}
                      signinPath="/StudentSignin"
                    />
                  )}

                  {/* {path === "qrCode" && (
                    <RestrictedRoute
                      path={`${match.url}qrCode`}
                      component={QrCodeApp}
                      authUser={qrCodeAuth}
                      signinPath="/QrCode"
                    />
                  )} */}

                  <Route path="/ApplicantSignin" component={ApplicantSignin} />
                  <Route path="/AdminSignin" component={AdminSignin} />
                  <Route path="/StudentSignin" component={StudentSignin} />
                  <Route path="/QrCode" component={QrCode} />
                  <Route path="/paymentreceipt" component={PaymentReceipt} />
                  <Route path="/AdmissionLetter" component={AdmissionLetter} />
                  <Route path="/SiwesLetter" component={SiwesLetter} />

                  <Route path="/signin" component={SignIn} />
                  <Route path="/" exact component={Home} />
                  <Route path="/forgotPassword" component={ForgotPassword} />
                  <Route
                    path="/ConfirmNewPassword"
                    component={ConfirmNewPassword}
                  />
                  <Route
                    component={asyncComponent(() =>
                      import("app/routes/extraPages/routes/404")
                    )}
                  />
                </Switch>
              </div>
            </RTL>
          </IntlProvider>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const {
    themeColor,
    sideNavColor,
    darkTheme,
    locale,
    isDirectionRTL,
  } = settings;
  const { authUser, initURL } = auth;
  const applicantAuth = auth.applicantUser;
  const adminAuth = auth.adminUser;
  const studentAuth = auth.studentUser;
  const qrCodeAuth = auth.qrCodeAuth;
  return {
    themeColor,
    sideNavColor,
    isDarkTheme: darkTheme,
    locale,
    isDirectionRTL,
    authUser,
    initURL,
    applicantAuth,
    adminAuth,
    studentAuth,
    qrCodeAuth,
  };
};

export default connect(mapStateToProps, { setInitUrl })(App);
